module.exports = __webpack_public_path__ + "static/media/Buzzer_Helloween_Markus.449b09f4.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sound/Buzzer_Helloween_Markus.mp3
// module id = 285
// module chunks = 0